<template>
    <input ref="input" type="text" autocomplete="off" name="date" :class="classes" :min="min_date" :max="max_date" :value="value" :placeholder="placeholder" class="js-datetimepicker">
</template>
<script>
    export default {
        name: 'datetimepicker',
        props: {
            value: {},
            format: {},
            timepicker: {},
            datepicker: {},
            placeholder: {},
            classes: {},
            min_date: {},
            max_date: {},
            default_date: {},
            step: {},
            disable_weekends: {
                default: false,
            },
            time_options: {},
            time_options_sunday: {},
            is_sunday: {},
            is_disable_sunday: {
                default: false,
            },
        },
        data: function() {
            return {
                datepicker_object: null,
                initiated: false,
            }
        },
        created: function() {
            this.initDateTimePicker();
            window.addEventListener('load', this.initDateTimePicker);
        },
        beforeDestroy: function() {
            $(this.$refs.input).datetimepicker('destroy');
        },
        methods: {
            /**
             * Initialize date time picker and set on change
             *
             * @author Rick van der Burg <rick@click.nl>
             * @author Bas Lokerman <bas@click.nl>
             * Last update: @author Robin van Leeuwen <robin@click.nl>
             *
             * @return void
             */
            initDateTimePicker: function() {
                if ($(this.$refs.input).datetimepicker == undefined) {
                    return;
                }

                this.$nextTick(function() {
                    var vm = this;

                    this.datepicker_object = $(this.$refs.input).datetimepicker({
                        lang: 'nl',
                        scrollInput: false,
                        step: this.step || 60,
                        timepicker: (this.timepicker == true ? true : false),
                        datepicker: (this.datepicker == true ? true : false),
                        format: this.format,
                        allowTimes: (this.is_sunday == true ? this.time_options_sunday : this.time_options) || [],
                        minDate: this.min_date || new Date().toISOString().split("T")[0],
                        maxDate: this.max_date || null,
                        defaultDate: this.default_date || new Date().toISOString().split("T")[0],
                        formatDate: 'd-m-Y',
                        defaultTime: (this.is_sunday == true ? '11:00' : '09:00'),
                        minTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: "2-digit" }),
                        beforeShowDay: this.getBeforeShowDay,
                        onSelectDate: function(date, i) {
                            var today = new Date();
                            var day = date.getDay();

                            // If user has chosen today
                            if(today.setHours(0,0,0,0) == date.setHours(0,0,0,0)) {
                                // Set min time to current time
                                this.setOptions({
                                    minTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: "2-digit" }),
                                });
                            } else {
                                // If it's not today, select minTime based on first selectable time
                                this.setOptions({
                                    minTime: (vm._props.is_sunday == true && day == 0 ? '11:00' : '09:00'),
                                });
                            }
                            // If Sunday and time options for Sunday are not undefined
                            if( day == 0 && vm._props.time_options_sunday !== undefined) {
                                // Set allowTimes and default time options for Sunday
                                this.setOptions({
                                    allowTimes: vm._props.time_options_sunday,
                                    defaultTime: '11:00',
                                });
                            } else {
                                // Set allowTimes and default time options for Mon-Sat
                                this.setOptions({
                                    allowTimes: vm._props.time_options || [],
                                    defaultTime: '09:00',
                                });
                            }
                            this.hide();
                        },
                        onChangeDateTime: function(dp, $input) {
                            vm.$emit('input', $input.val());
                        }
                    });

                    this.initiated = true;
                });
            },
            /**
             * Get the beforeShowDay setting based on the set params
             * This function is used to disable certain days
             * 
             * @author Bas Lokerman <bas@click.nl>
             * @param object date
             *
             * @return array|null;
             */
            getBeforeShowDay: function (date){
                //If disable weekends is true
                if (this.disable_weekends == true) {
                    var day = date.getDay();
                    //Disable Saturday(6) and Sunday(0)
                    return [(day != 0 && day != 6), ''];

                //If disable sunday is true
                } else if(this.is_disable_sunday == true) {
                    var day = date.getDay();
                    //Disable Sunday(0)
                    return [(day != 0), ''];
                }
                return null;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/components/fields/datetimepicker.vue